/* * 地图图层树 * @module components/layertree/LayerTree * @desc 用于图层树 * @author zhaoting *
@date 2019年12月19日 */
<template>
  <div>
    <div class="layercount">
      <div>
        已选<span>{{ layersData.length }}</span
        >个图层
      </div>
      <div class="right">
        <i class="iconfont icon-piliangshanchu1" title="批量删除" @click="deleteAllLayer"></i>
      </div>
    </div>
    <div id="layer-pop" class="tmp">
      <ul v-for="(item, index) in layersData" class="ui-sortable" :key="item.id">
        <li :data-id="item.id">
          <Checkbox v-model="item.checked" @on-change="ChangeLayer(item)">
            <div
              class="icontype"
              :class="
                item.icon == 'line'
                  ? 'iconline'
                  : item.icon == 'polygon'
                  ? 'iconpoly'
                  : item.icon == 'point'
                  ? 'iconpoint'
                  : 'iconpoly2'
              "
            ></div>
            <span style="color: black">&nbsp;{{ item.title }}</span>
          </Checkbox>
          <Icon
            type="md-trash"
            title="移除"
            style="
              color: rgb(0, 153, 250);
              float: right;
              margin-right: 10px;
              margin-top: 5px;
              font-size: 16px;
            "
            @click="deleteLayer(item, index)"
          />
          <Icon
            style="
              color: rgb(0, 153, 250);
              float: right;
              margin-right: 10px;
              margin-top: 5px;
              font-size: 16px;
            "
            type="ios-color-filter"
            title="图例"
            class="slider1"
            @click="showlegend(item)"
          />
          <Icon
            style="
              color: rgb(0, 153, 250);
              float: right;
              margin-right: 10px;
              margin-top: 5px;
              font-size: 16px;
            "
            type="ios-pin"
            title="定位"
            class="slider1"
            @click="setCenterlayer(item)"
          />
          <Icon
            style="
              color: rgb(0, 153, 250);
              float: right;
              margin-right: 10px;
              margin-top: 5px;
              font-size: 16px;
            "
            type="md-photos"
            class="slider1"
            title="查看属性"
            @click="showproperty(item)"
          />
          <br />
          <Slider
            class="slider1"
            ref="item.title"
            v-model="item.value"
            style="width: 90%"
            @on-input="sliderLayer(item)"
          ></Slider>
        </li>
      </ul>
    </div>

    <Modal
      id="legendTree"
      v-model="ledendModal"
      scrollable
      @on-cancel="hidelegend"
      :mask-closable="false"
      :footer-hide="true"
      draggable
      :mask="false"
      :width="230"
    >
      <table class="formTable">
        <tbody>
          <tr>
            <td
              style="color: blue; cursor: pointer"
              @click="showlegendall()"
              v-if="legendctrl == 'show'"
            >
              显示全部
            </td>
            <td
              style="color: blue; cursor: pointer"
              @click="closelegendall()"
              v-if="legendctrl == 'hide'"
            >
              隐藏全部
            </td>
            <!-- <td style="color: blue; cursor: pointer" @click="closelegendall()">关闭全部</td> -->
          </tr>
          <tr>
            <img :src="legendData" />
            <!-- <td v-for="(itm, inx) in legendData" :key="inx">
              <b style="display: none">{{ itm.layerName }}</b>
              <table>
                <tbody>
                  <tr valign="middle" v-for="(aitm, ainx) in itm.legend" :key="ainx">
                    <td @click="showlegendfilter(itm, aitm)" style="cursor: pointer">
                      <div class="labdiv">
                        <div class="labzg" v-show="!aitm.check"></div>
                        <img :src="'data:image/png;base64,' + aitm.imageData" :alt="aitm.label" />
                      </div>

                    </td>
                    <td>{{ aitm.label }}</td>
                  </tr>
                </tbody>
              </table>
            </td> -->
          </tr>
        </tbody>
      </table>
    </Modal>
  </div>
</template>
<script>
import LayerTree from './LayerTree';
export default LayerTree;
</script>
<style lang="less" scoped>
#layer-all {
  width: 17%;
  height: 40%;
  position: absolute;
  right: 17.5%;
  top: 120px;
}

#layer-title {
  width: 100%;
  height: 40px;
  // position: absolute;
  // right: 18%;
  // top: 120px;
  background-color: #0099fa;
  z-index: 3;
}
#title {
  color: white;
  margin-top: 8px;
  margin-left: 20px;
  position: absolute;
  height: 20px;
  width: 100%;
}
.layercount {
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
}
.layercount span {
  color: red;
}
#layer-pop {
  width: 100%;
  height: calc(~'100% - 20px');
  border-radius: 2px;
  background-color: #fff;
  z-index: 3;
  overflow: auto;
}

#layer-pop > .title {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 10px;
}
.ui-sortable {
  -webkit-user-select: none;

  -moz-user-select: none;

  -ms-user-select: none;

  user-select: none;
}

.icontype {
  // margin-right: 5px;
  width: 17px;
  height: 13px;
  background-repeat: no-repeat;
  display: inline-block;
}
.iconpoint {
  background-image: url(../../../static/image/layericon/point.png);
}
.iconline {
  background-image: url(../../../static/image/layericon/line.png);
}
.iconpoly {
  background-image: url(../../../static/image/layericon/fill.png);
  position: relative;
  top: 2px;
}
.iconpoly2 {
  background-image: url(../../../static/image/layericon/polygon2.png);
  position: relative;
  top: 3px;
}
/*#layer-pop>ul {
padding-top: 20px;
}*/

#layer-pop li {
  font-size: 12px;
  padding-left: 20px;
  height: auto;
  line-height: 25px;
  border-bottom: 1px solid #e8eaec;
}

#layer-pop ul > li:hover {
  cursor: pointer;
  background: rgba(0, 153, 204, 0.2);
}
#layer-pop li > .opa {
  font-size: 10px;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 2px;
  width: 26px;
  height: 18px;
  outline: none;
  color: #ef0907;
  margin-left: 5px;
  cursor: text;
}

#layer-pop li > .opa:focus {
  outline: none;
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
#layer-pop::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
#layer-pop::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #3083b7;
}
#layer-pop::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #dadee4;
}

#layer-pop .ivu-slider-bar {
  height: 4px;
  background: #0099fa;
  border-radius: 3px;
  position: absolute;
}
#layer-pop .ivu-slider-button {
  width: 12px;
  height: 12px;
  border: 2px solid #0099fa;
  border-radius: 50%;
  background-color: #fff;
  transition: all 0.2s linear;
  outline: 0;
}
#layer-pop .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #0099fa;
  background-color: #0099fa;
}
#layer-pop .ivu-checkbox-wrapper {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  margin-right: 8px;
}

#legendTree {
  /deep/ .ivu-modal {
    float: right;
    margin-right: 10px;
    margin-top: 10%;
  }
  /deep/ .ivu-modal-body {
    height: 360px;
    overflow: auto;
    padding: 0px !important;
  }
}
#legendTree .ivu-modal-content {
  width: 230px;
  right: 21px;
  top: 225px;
}
.formTable {
  padding: 5px;
  // margin: 10px 0px 3px;
  // border: #000 1px solid;
  // background-color: #e5eff7;
  width: 100%;
}
.formTable td {
  padding-right: 11px;
  padding-left: 0px;
  font-size: 0.9em;
  padding-bottom: 5px;
  margin: 0px 0px 3px;
  padding-top: 3px;
  display: inline-block;
}
.formTable b {
  font-weight: bold;
}
.formTable .labdiv {
  position: relative;
  text-align: center;
  padding: 0;
  .labzg {
    background: rgba(170, 170, 170, 0.7);
    display: inline-block;
    height: 22px;
    width: 22px;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layertree/LayerTree.vue